import Footer from '../home/Footer';

const RekordboxHowTo = () => {
  return (
      <div>
          <div className={'infoPage'}>
              <h1>How to broadcast with recordbox for free</h1>
              <p>
                  Coming soon...
              </p>
          </div>
          <Footer/>
      </div>
  );
};

export default RekordboxHowTo;
